import { RemuneracaoMedica } from '@/types/core'
import { ItemFeriado } from '@/types/interfaces/FinanceiroTypes'
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'

@Module({ namespaced: true, name: 'FeriadoStore' })
export default class FeriadoStore extends VuexModule {
  private itemFeriadoDefault: ItemFeriado = {
    id: '',
    data: '',
    descricao: '',
    nome: '',
    observacao: '',
    criadoPor: '',
    criadoEm: '',
    tipo: {
      key: '',
      display: '',
    },
  }

  public modal = {
    itemFeriado: false,
  }

  public tiposFeriadoList: any[] = [
    { key: 'Nacional', display: 'Nacional' },
    { key: 'Estadual', display: 'Estadual' },
    { key: 'Municipal', display: 'Municipal' },
  ]

  public itemFeriado: ItemFeriado = { ...this.itemFeriadoDefault }
  public originalItemFeriado: ItemFeriado = { ...this.itemFeriadoDefault }
  public modalContext: any = null
  public total: number = 0
  public pagina: number = 1
  public qtdPorPagina: number = 20
  public feriadoList: ItemFeriado[] = []
  itemToDeleteId: any = null
  remuneracaoMedica: RemuneracaoMedica.IPrestadorRecebimento = new RemuneracaoMedica.PrestadorRecebimento()

  @Mutation
  clearItemFeriado() {
    this.itemFeriado = { ...this.itemFeriadoDefault }
  }

  @Mutation
  clearFeriadoList() {
    this.feriadoList = []
  }

  @Mutation
  setItemFeriado(itemFeriado: ItemFeriado) {
    this.itemFeriado = itemFeriado
  }

  @Mutation
  setItemToDeleteId(id: any) {
    this.itemToDeleteId = id
  }

  @Mutation
  setFeriadoList(feriadoList: ItemFeriado[]) {
    this.feriadoList = feriadoList
  }

  @Mutation
  setOriginalItemFeriado(value: ItemFeriado) {
    this.originalItemFeriado = value
  }

  @Mutation
  setModal(modal: { name: string; value: any; context?: string }) {
    this.modal[modal.name] = modal.value
    this.modalContext = modal.context || null
  }

  @Mutation
  removeItemFeriado(id: string) {
    const index = this.feriadoList.findIndex((e: any) => e.id === id)
    this.feriadoList.splice(index, 1)
  }

  @Mutation
  setFeriadoListPagina(pagina: number) {
    this.pagina = pagina
  }

  @Mutation
  setFeriadoListTotal(total: number) {
    this.total = total
  }

  @Action
  async deleteItemFeriado() {
    try {
      const param: any = {
        id: this.itemToDeleteId,
      }
      const request = await this.remuneracaoMedica.deleteItemFeriado(param)
      if (request.success) this.context.commit('removeItemFeriado', param.id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar o registro.' }
    }
  }

  @Action
  async getAllItemsFeriado() {
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
      }

      const request = await this.remuneracaoMedica.getAllFeriados(params)

      if (request.success) {
        this.context.commit('setFeriadoList', request.data.itens as ItemFeriado[])
        this.context.commit('setFeriadoListPagina', request.data.paginaAtual || 1)
        this.context.commit('setFeriadoListTotal', request.data.totalRegistros || 0)
      }

      return request
    } catch (error) {
      this.context.commit('setItemsSenioridade', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async createItemFeriado() {
    try {
      const params: any = {
        id: null,
        data: this.itemFeriado.data,
        nome: this.itemFeriado.nome,
        observacao: this.itemFeriado.observacao,
        tipo: this.itemFeriado.tipo.key,
      }
      const request = await this.remuneracaoMedica.createItemFeriado(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async updateItemFeriado() {
    try {
      const params: any = {
        id: this.itemFeriado.id,
        data: this.itemFeriado.data,
        nome: this.itemFeriado.nome,
        observacao: this.itemFeriado.observacao,
        tipo: this.itemFeriado.tipo.key,
      }
      const request = await this.remuneracaoMedica.updateItemFeriado(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
